<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold">{{ $t('select_outlet') }}</span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-autocomplete
          outlined
          dense
          clearable
          hide-details
          :items="outlets"
          :loading="isLoading"
          :search-input.sync="search"
          item-text="name"
          label="Search for a outlet"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                {{ $t('outlet_not_found') }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ data.item.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="black--text font-weight-regular">
                <template v-if="data.item.address">
                  {{ data.item.address }},
                </template>
                {{ data.item.city_name }}, {{ data.item.country_name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="grey--text darken-1 font-weight-regular caption">
                <!-- {{ distance[idx] }} -->
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-list three-line class="list-outlets">
          <template v-for="(list, idx) in outlets">
            <v-list-item v-if="Number(list.location_lat) !== 0 && Number(list.location_lon) !== 0" :key="idx + '-outlet'" :disabled="storeClose.disabled[idx]" @click="selectOutlet(list.url_id, list)">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold two-line--text">
                  {{ list.name }} {{ storeClose.discription[idx] }}
                </v-list-item-title>
                <v-list-item-subtitle class="black--text font-weight-regular three-line--text">
                  <template v-if="list.address">
                    {{ list.address }},
                  </template>
                  {{ list.city_name }}, {{ list.country_name }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="list.location_distance" class="grey--text darken-1 font-weight-regular caption">
                  {{ list.location_distance.text }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="idx" />
          </template>
        </v-list>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogUniqueCode" persistent max-width="280">
      <v-card>
        <div class="card-unique-code">
          <v-btn icon class="btn-close-card-unique" @click="dialogUniqueCode = false">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
          <div class="card-unique-code-title">
            {{ $t('enter_code_here') }}
          </div>
          <div class="card-unique-code-subtitle">
            {{ $t('get_code_from_cashier') }}
          </div>
          <div class="my-6">
            <div class="">
              <InputCode v-model="form.code" :error-message="error_unique_code" />
            </div>
          </div>
          <v-btn v-if="!loadingCode" type="submit" large color="primary" block class="text-none" @click="validateCode()">
            {{ $t('next') }}
          </v-btn>
          <div v-else class="d-flex align-center justify-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { debounce } from 'debounce'
import {
  getData as getDataOutlet
} from '@/api/outlet'
import {
  geoCodeByLatLng as geoCodeByLatLngMaps,
  distanceMatrix as distanceMatrixMaps
} from '@/api/maps'
import {
  dineinchecking as dineinCheck
} from '@/api/setting'
import InputCode from '@/components/modules/InputCode'
export default {
  components: {
    InputCode
  },
  data() {
    return {
      error_unique_code: '',
      loadingCode: false,
      dialogUniqueCode: false,
      form: {
        code: ''
      },
      isLoading: false,
      search: null,
      outlets: [],
      storeClose: {
        disabled: [],
        discription: []
      },
      params_outlet: {
        origin_lat: 0,
        origin_lon: 0
      },
      dataCheckoutDelivery: {
        shipping_address: '',
        shipping_delivery_type: 1,
        shipping_time: '',
        shipping_radius: 0,
        shipping_lat: 0,
        shipping_lon: 0,
        item: []
      },
      distanceForm: {
        origin_lat: 0,
        origin_lon: 0,
        destination: []
      }
    }
  },
  watch: {
    watch: {
      search: {
        handler: debounce(async function(val) {
          if (!val) return
          if (this.isLoading) return

          this.isLoading = true
          try {
            const { data } = await getDataOutlet({ search: val })
            this.$store.state.loading_axios = false

            const { count, entries } = data.data
            this.count = count
            this.outlets = entries
          } catch (e) {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          } finally {
            this.isLoading = false
          }
        }, 2000)
      }
    }
  },
  created: function() {
    this.checkNav()
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))) {
      this.dataCheckoutDelivery = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))
    }
  },
  beforeDestroy() {
    this.$store.state.must_allow_location = false
  },
  methods: {
    successPosition: async function(position) {
      this.distanceForm.destination.push({
        lat: Number(position.coords.latitude),
        lon: Number(position.coords.longitude)
      })

      this.params_outlet.origin_lat = position.coords.latitude
      this.params_outlet.origin_lon = position.coords.longitude
      this.loadOutlet(this.params_outlet)
      if (this.$store.state.selected_type === 'DELIVERY') {
        if (this.dataCheckoutDelivery.shipping_address === '') {
          const form = {
            lat: position.coords.latitude,
            lon: position.coords.longitude
          }
          this.getAddress(form).then((data) => {
            this.dataCheckoutDelivery.shipping_address = data
          })
        }
        if (this.dataCheckoutDelivery.shipping_lat === 0) {
          this.dataCheckoutDelivery.shipping_lat = position.coords.latitude
        }
        if (this.dataCheckoutDelivery.shipping_lon === 0) {
          this.dataCheckoutDelivery.shipping_lon = position.coords.longitude
        }
        this.$store.dispatch('saveDataCartDelivery', this.dataCheckoutDelivery)
      }
    },
    failurePosition: function() {
      this.loadOutlet()
      if (this.$store.state.selected_type === 'DELIVERY') {
        this.$store.state.must_allow_location = true
      }
      this.$store.state.block_location = true
    },
    async checkNav() {
      if (navigator.geolocation) {
        await navigator.geolocation.getCurrentPosition(this.successPosition, this.failurePosition, {
          enableHighAccuracy: true,
          timeout: 5000
        })
      } else {
        alert(`Browser doesn't support Geolocation`)
      }
    },
    async loadOutlet(params = {}) {
      try {
        const { data } = await getDataOutlet(params)
        this.$store.state.loading_axios = false
        this.outlets = data.data
        for (var i = 0; i < this.outlets.length; i++) {
          if (this.$store.state.selected_type === 'DINE-IN' && this.outlets[i].setting.use_dinein === 1) {
            if (this.outlets[i].store_is_open === 1) {
              this.storeClose.disabled[i] = false
              this.storeClose.discription[i] = ''
            } else {
              this.storeClose.disabled[i] = true
              this.storeClose.discription[i] = '- (Toko Tutup)'
            }
          } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY' && this.outlets[i].setting.use_takeaway === 1) {
            if (this.outlets[i].store_is_open === 1) {
              this.storeClose.disabled[i] = false
              this.storeClose.discription[i] = ''
            } else {
              this.storeClose.disabled[i] = true
              this.storeClose.discription[i] = '- (Toko Tutup)'
            }
          } else if (this.$store.state.selected_type === 'DELIVERY' && this.outlets[i].setting.use_delivery === 1) {
            if (this.outlets[i].store_is_open === 1) {
              this.storeClose.disabled[i] = false
              this.storeClose.discription[i] = ''
            } else {
              this.storeClose.disabled[i] = true
              this.storeClose.discription[i] = '- (Toko Tutup)'
            }
          } else if (this.$store.state.selected_type === 'RESERVATION') {
            if (this.outlets[i].store_is_open === 1) {
              this.storeClose.disabled[i] = false
              this.storeClose.discription[i] = ''
            } else {
              this.storeClose.disabled[i] = false
              this.storeClose.discription[i] = '- (Toko Tutup)'
            }
          } else {
            this.storeClose.disabled[i] = true
            this.storeClose.discription[i] = '- (Toko Tutup)'
          }
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async selectOutlet(data, dataOutlet) {
      this.$store.state.loading = true
      this.$store.dispatch('saveSelectedId', dataOutlet.id)
      const obj = {
        url_id: dataOutlet.url_id,
        id: dataOutlet.id
      }
      var destinations = []
      var origins = {}
      await this.$store.dispatch('fetchOutlet', obj)
      if (this.$store.state.selected_type === 'DELIVERY') {
        if (this.dataCheckoutDelivery.shipping_lat === 0 || this.dataCheckoutDelivery.shipping_lon === 0) {
          destinations = [...this.distanceForm.destination]
        } else {
          destinations.push({
            lat: Number(this.dataCheckoutDelivery.shipping_lat),
            lon: Number(this.dataCheckoutDelivery.shipping_lon)
          })
        }
      } else {
        destinations = [...this.distanceForm.destination]
      }
      origins.lat = Number(dataOutlet.location_lat)
      origins.lon = Number(dataOutlet.location_lon)
      const _this = this
      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$router.push({ name: 'take_away' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        this.$router.push({ name: 'reservation' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        if (dataOutlet.setting.use_unique_code_checking_dinein === 0) {
          // request pak ali remove gps tanggal 24 oktober 2022
          this.$router.push({ name: 'select_table' }).catch(() => {})

          // const radiusDinein = await this.$curDistance(origins.lat, origins.lon, destinations[0].lat, destinations[0].lon)
          // if (radiusDinein > 250) {
          //   this.$store.state.block_tooLong = true
          // } else {
          //   this.$router.push({ name: 'select_table' }).catch(() => {})
          // }
        } else {
          this.dialogUniqueCode = true
        }
      } else {
        const form = {
          origin_lat: origins.lat,
          origin_lon: origins.lon,
          destination: destinations
        }
        this.calcDistance(form).then((data) => {
          if (data.elements[0].status !== 'ZERO_RESULTS') {
            _this.$set(_this.dataCheckoutDelivery, 'shipping_radius', Math.ceil(data.elements[0].distance.value / 1000))
            _this.dataCheckoutDelivery.item = []
            _this.$store.dispatch('saveDataCartDelivery', _this.dataCheckoutDelivery)
            _this.$router.push({ name: 'delivery' }).catch(() => {})
          } else {
            _this.$store.state.outside_radius = true
          }
        })
      }
      this.$store.state.loading = false
    },
    async calcDistance(dataDistance) {
      try {
        const { data } = await distanceMatrixMaps(dataDistance)
        this.$store.state.loading_axios = false
        if (data.status === 'ZERO_RESULTS') {
          this.$router.push({ name: 'home' }).catch(() => {})
        } else {
          return data.rows[0]
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async getAddress(dataLocation) {
      try {
        const { data } = await geoCodeByLatLngMaps(dataLocation)
        this.$store.state.loading_axios = false
        return data.results[0].formatted_address
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
        return ''
      }
    },
    async validateCode() {
      this.error_unique_code = ''
      this.loadingCode = true
      try {
        await dineinCheck(this.form)
        this.$store.state.loading_axios = false
        this.$router.push({ name: 'select_table' }).catch(() => {})
      } catch (e) {
        this.error_unique_code = e.string
      }
      this.loadingCode = false
      this.form.code = ''
    }
  }
}
</script>
